import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { REDIRECT_KEY } from '../../constents/text';
import useRedirect from '../../Hooks/Auth/useRedirect';
import { REDEEM_CREDIT_URL } from '../../Utils/apis';

const MockRedeemPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const { redirectUrlSetter } = useRedirect();
//   const isUserAuthenticated = useSelector(state => state?.authStates?.isUserAuthenticated);
//   const isUserRegistered = useSelector(state => Boolean(state?.user?.Candidate_Id));
const isUserRegistered = useSelector(state => Boolean(state?.user?.Candidate_Id));
//   const userId = useSelector(state => state?.user?._id);
  const tokenFromUrl = searchParams.get('token');
  

//   useEffect(() => {
//     // Check presence of token
//     if (!tokenFromUrl) {
//       // no token, navigate to home or mock
//       navigate('/mock');
//       return;
//     }
//     else if(!candidate_id) {
//       // Save current URL for redirect after login
//       redirectUrlSetter();
//       navigate('/pricing');
//       return;
//     }

//     // Handle user login/registration redirection
//     // if (!isUserRegistered) {
//     //   // Save current URL
//     //   redirectUrlSetter();
//     //   // Redirect to registration page
//     //   navigate('/auth/register');
//     //   return;
//     // }


//     // If logged in, call API to validate & redeem token
//     redeemToken();
//   }, [ tokenFromUrl, navigate]);

 useEffect(() => {
    if (!tokenFromUrl) {
      navigate('/mock');
      return;
    }

    redeemToken();
  }, [tokenFromUrl]);

  const redeemToken = async () => {
    try {
      // Call your backend API to validate & redeem token
      const response = await fetch(REDEEM_CREDIT_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // If using cookies for auth, no need headers for auth
        },
        body: JSON.stringify({ token: tokenFromUrl }),
        credentials: 'include', // include cookies
      });
      if (!response.ok) {
        // handle error, maybe show a message to user
        alert('Failed to redeem token!');
        navigate('/mock');
        return;
      }
      // Success: deduct completed, go to `/mock`
      alert('Token redeemed successfully!'); // optional
      navigate('/mock'); // redirect to main mock list page
    } catch (err) {
      console.error('Redeem token error:', err);
      alert('Error during redemption');
      navigate('/mock');
    }
  };

  return (
    <div className="h-screen flex items-center justify-center bg-gray-100">
      <p className="text-lg font-semibold">Processing your token... Please wait.</p>
    </div>
  );
};

export default MockRedeemPage;
